var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdaWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-16 -16 2469 720",
    role: "img",
    "aria-label": "AdA.",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F172A",
    d: "M535 688 506 591H265L236 688H10L261 0H518L769 688ZM311 437H460L388 192H384ZM1212 688 1195 613Q1137 700 1027 700Q920 700 862.0 630.0Q804 560 804 423Q804 287 862.0 217.5Q920 148 1027 148Q1118 148 1175 209V-37H1374V688ZM1003 398V451Q1003 553 1089 553Q1133 553 1155.0 522.0Q1177 491 1177 441V408Q1177 358 1155.0 326.5Q1133 295 1089 295Q1003 295 1003 398ZM1960 688 1931 591H1690L1661 688H1435L1686 0H1943L2194 688ZM1736 437H1885L1813 192H1809Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2332,
    cy: 583,
    r: 105,
    fill: "#7C3AED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaWordmark);
export default __webpack_public_path__ + "static/media/ada-wordmark.e6256b02d20529312014c150e448ff4f.svg";
export { ForwardRef as ReactComponent };